import { ComponentError } from "../../ErrorPages/ComponentsError";
import { CircularProgress } from "@mui/material";

const HandleRequests = ({ children, error, loading }) => {
  const divStyle = {
    width: "100%",
    minHeight: "500px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  return (
    <>
      {error?.error ? (
        <ComponentError code={error?.code} />
      ) : (
        <>
          {loading ? (
            <div style={divStyle}>
              <CircularProgress size={"4rem"} />
            </div>
          ) : (
            children
          )}
        </>
      )}
    </>
  );
};

export default HandleRequests;
